module.exports = __webpack_public_path__ + "static/DesigningImg-aed36a8de83b37d903931bd9b1df1bff.jpg";